import React, { useState } from "react";
import axios from "axios";
import Style from "../Style/UserRegister.module.scss";
import { FaEye, FaEyeSlash, FaUserCircle } from "react-icons/fa"; // 👈 added
import { Link, useNavigate } from "react-router-dom";

const UserRegister = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });
  const baseURL = process.env.REACT_APP_BASE_URL;

  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const res = await axios.post(`${baseURL}/api/register`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      setMessage(res.data.message || "Registration successful");
      setFormData({ name: "", email: "", password: "" });

      setTimeout(() => {
        navigate("/user-login");
      }, 1000);
    } catch (err) {
      setMessage(err.response?.data?.error || "Something went wrong");
    }
  };

  return (
    <div className={Style.Register}>
      <div className={Style.wrapper}>
        <div className={Style.RegisterDisk}>
          <FaUserCircle className={Style.RegisterIcon} /> {/* 👈 New Icon */}
          <h2>User Registration</h2>
        </div>
        <div className={Style.RegisterForm}>
          <form onSubmit={handleSubmit} className={Style.Form}>
            <div className={Style.RegisterInput}>
              <input
                type="text"
                name="name"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className={Style.RegisterInput}>
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className={`${Style.RegisterInput} ${Style.PasswordField}`}>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Enter your password"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <span
                className={Style.ToggleIcon}
                onClick={togglePasswordVisibility}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            <div className={Style.RegisterSubmit}>
              <button type="submit">Register</button>
            </div>
            <div className={Style.Registeralredy}>
              <Link to="/user-login">Already registered?</Link>
            </div>
          </form>
          {message && <p className={Style.Message}>{message}</p>}
        </div>
      </div>
    </div>
  );
};

export default UserRegister;
